module.exports = __webpack_public_path__ + "static/media/loader.5d77e120.gif";